// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signin-main {
  /* background-color: var(--primary-color); */
  /* width: 35%; */
  width: 70%;
}
/* .signin,
.signup {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 45%;
  height: 100vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
} */
.signin .login-form {
  /* background-color: white; */
  /* box-shadow: var(--boxShadow); */
  margin: 1.25rem 0;
  /* border: 0.063rem #ddd solid; */
  padding: 1.25rem;
  border-radius: 0.313rem;
  width: 100%;
}
.signin .login-form h2 {
  font-weight: bold;
  color: white !important;
}
.signin .login-form button {
  width: 100%;
  height: 2.5rem;
  border: none;
  font-weight: normal;
  box-shadow: var(--boxShadow);
  letter-spacing: 0.063rem;
  background-color: white;
  color: black;
  /* background-color: var(--secondary-color); */
}
.signin .for-signup {
  text-align: center;
  width: 100%;
}
.signin .for-signup button {
  width: 100%;
  height: 2.5rem;
  margin: 0.625rem auto;
  border-color: #adb1b8 #a2a6ac #8d9096;
  border: 0.063rem solid;
  background: linear-gradient(to bottom, #f7f8fa, #e7e9ec);
}

.signin .for-signup .signin-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 47%;
}
.signin .for-signup .signin-btn svg {
  margin-right: 0.625rem;
  font-size: 1.25rem;
}
.signin .for-signup .signin-gf {
  display: flex;
}

/* forget password  */
.signin-forget {
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  text-align: center;
}
.signin-forget .forget-inner {
  width: 40%;
  height: 12.5rem;
}
.signin-forget img,
.signin-forget h4,
.signup img,
.signup h4 {
  margin-bottom: 1.25rem;
}
.for-signup h4 {
  margin: 0.625rem 0;
}

.signin-forget p {
  margin-top: 1.25rem;
  letter-spacing: 0.063rem;
}
.signin-forget button {
  width: 6.25rem;
  display: block;
  margin: 1.25rem auto 0 auto;
}

/* signup */

.signup {
  margin: 1.875rem auto;
}

/* media queries */

/* @media (max-width: 74.375rem) {
  .signin,
  .signin-forget .forget-inner,
  .signup {
    width: 60%;
  }
} */
@media (max-width: 53.125rem) {
  .signin,
  .signup,
  .signin-forget .forget-inner {
    width: 90%;
  }
}

.signin .ant-form-item-label label {
  color: white;
}
.signin .ant-input-affix-wrapper,
.signin .ant-input {
  color: white;
  background: transparent;
  border: none;
  border-bottom: 0.063rem solid;
}
.signin-main .signin .login {
  background-color: #5dbea8;
  border-radius: 1.25rem;
  color: white;
}
.signin-main .signin .hanker {
  background-color: #8a1c6c;
  width: auto;
  border-radius: 0.625rem;
  color: white;
}
.signin-main .signin .btn_container div div div {
  display: flex;
  flex-direction: column;
  gap: 1.875rem;
  align-items: center;
}
.signin-main .signin .anticon svg {
  color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/login.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,UAAU;AACZ;AACA;;;;;;;;;;;;GAYG;AACH;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,qCAAqC;EACrC,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;;;;EAIE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,cAAc;EACd,2BAA2B;AAC7B;;AAEA,WAAW;;AAEX;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;;AAElB;;;;;;GAMG;AACH;EACE;;;IAGE,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".signin-main {\n  /* background-color: var(--primary-color); */\n  /* width: 35%; */\n  width: 70%;\n}\n/* .signin,\n.signup {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 45%;\n  height: 100vh;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n} */\n.signin .login-form {\n  /* background-color: white; */\n  /* box-shadow: var(--boxShadow); */\n  margin: 1.25rem 0;\n  /* border: 0.063rem #ddd solid; */\n  padding: 1.25rem;\n  border-radius: 0.313rem;\n  width: 100%;\n}\n.signin .login-form h2 {\n  font-weight: bold;\n  color: white !important;\n}\n.signin .login-form button {\n  width: 100%;\n  height: 2.5rem;\n  border: none;\n  font-weight: normal;\n  box-shadow: var(--boxShadow);\n  letter-spacing: 0.063rem;\n  background-color: white;\n  color: black;\n  /* background-color: var(--secondary-color); */\n}\n.signin .for-signup {\n  text-align: center;\n  width: 100%;\n}\n.signin .for-signup button {\n  width: 100%;\n  height: 2.5rem;\n  margin: 0.625rem auto;\n  border-color: #adb1b8 #a2a6ac #8d9096;\n  border: 0.063rem solid;\n  background: linear-gradient(to bottom, #f7f8fa, #e7e9ec);\n}\n\n.signin .for-signup .signin-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 47%;\n}\n.signin .for-signup .signin-btn svg {\n  margin-right: 0.625rem;\n  font-size: 1.25rem;\n}\n.signin .for-signup .signin-gf {\n  display: flex;\n}\n\n/* forget password  */\n.signin-forget {\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  height: 100vh;\n  text-align: center;\n}\n.signin-forget .forget-inner {\n  width: 40%;\n  height: 12.5rem;\n}\n.signin-forget img,\n.signin-forget h4,\n.signup img,\n.signup h4 {\n  margin-bottom: 1.25rem;\n}\n.for-signup h4 {\n  margin: 0.625rem 0;\n}\n\n.signin-forget p {\n  margin-top: 1.25rem;\n  letter-spacing: 0.063rem;\n}\n.signin-forget button {\n  width: 6.25rem;\n  display: block;\n  margin: 1.25rem auto 0 auto;\n}\n\n/* signup */\n\n.signup {\n  margin: 1.875rem auto;\n}\n\n/* media queries */\n\n/* @media (max-width: 74.375rem) {\n  .signin,\n  .signin-forget .forget-inner,\n  .signup {\n    width: 60%;\n  }\n} */\n@media (max-width: 53.125rem) {\n  .signin,\n  .signup,\n  .signin-forget .forget-inner {\n    width: 90%;\n  }\n}\n\n.signin .ant-form-item-label label {\n  color: white;\n}\n.signin .ant-input-affix-wrapper,\n.signin .ant-input {\n  color: white;\n  background: transparent;\n  border: none;\n  border-bottom: 0.063rem solid;\n}\n.signin-main .signin .login {\n  background-color: #5dbea8;\n  border-radius: 1.25rem;\n  color: white;\n}\n.signin-main .signin .hanker {\n  background-color: #8a1c6c;\n  width: auto;\n  border-radius: 0.625rem;\n  color: white;\n}\n.signin-main .signin .btn_container div div div {\n  display: flex;\n  flex-direction: column;\n  gap: 1.875rem;\n  align-items: center;\n}\n.signin-main .signin .anticon svg {\n  color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
